export default function() {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  
  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
      , detectIpad: IPADDETECTED
      // options
      , allEventsLink: true
      , allEventsLinkText: 'SEE ALL EVENTS'
      , hasImages: false
      , imageBackground: false
      , lazyLoadImages: true
      , buyNowButton: {visible: false, text: 'BUY NOW'}
      , moreButton: {visible: false, text: 'MORE'}
      , maxItemsVisible: 4
      , isResponsive: false
      , hasDescription: false
      , textContainer: true
      , link: 'all' //options are 'all', 'text', 'image', 'imageAndText', or ''
      , attributeOrder: {
        1: 'date',
        2: 'title',
        3: 'image',
        4: 'description',
        5: 'buttons'
      }
      , multiFeatureLoaded: function(data){
        if (data.length === 0) {
          $('.section-tier-two-top').addClass('no-events');
        }
        $(`#${widgetName}`).prepend('<h2>Upcoming Events</h2>');
        $(`#${widgetName} .all-events-btn`).addClass('button');
        $(`#${widgetName} .all-events-btn`).text('View Full Calendar');
 
        $('#multiScheduleFeature .featureItem').each(function() {
          var eventDate = $(this).find($('span.featureItemDate'));
          var datesMonth = eventDate.text().slice(0,3);
          var datesDay = eventDate.text().slice(4,7).replace(',','');
          eventDate.text(datesMonth);
          eventDate.append("<span>"+datesDay+"</span>");
        });
      }
  });

};

